import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { LocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { OauthSessionModule } from '@stg-js-ngx-core/oauth';
import { ToastrModule } from 'ngx-toastr';
import { LeftNavModule } from '@stg-js-ngx-core/left-nav';
import { HeaderModule } from '@stg-js-ngx-core/header';
import { FooterModule } from '@stg-js-ngx-core/footer';
import { DesktopModule } from '@stg-js-ngx-core/desktop';
import { PageHeaderModule } from '@stg-js-ngx-core/page-header';
import { BlockUIModule } from './common/block-ui';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { OAuthCallbackComponent } from './core/oauth-callback.component';
import { AuthInterceptor } from './core/auth.interceptor';
import { HospitalSelectorModule } from './common/components/hospital-selector/hospital-selector.module';
import { PageLoaderModule } from './common/components/page-loader/page-loader.module';
import { ModalRecommendationModule } from './common/components/modal-recommendation/modal-recommendation.module';
import { HierarchySelectorModule } from './common/components/hierarchy-selector/hierarchy-selector.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { SystemSelectorModule } from './common/components/system-selector/system-selector.module';
import { LandingCardsModule } from './common/components/landing-cards/landing-card-module';
import { ParameterHashLocationStrategy } from './ParameterHashLocationStrategy';
import { AppConfigService } from './appServiceConfig';

export function initConfig(appConfig: AppConfigService) {
  return () => appConfig.loadConfig();
}

@NgModule({
  declarations: [
    AppComponent,
    OAuthCallbackComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    OauthSessionModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      timeOut: 5000,
      closeButton: true,
      progressBar: true,
      preventDuplicates: true
    }),
    LeftNavModule,
    HeaderModule,
    FooterModule,
    DesktopModule,
    BlockUIModule,
    PageHeaderModule,
    HospitalSelectorModule,
    PageLoaderModule,
    ModalRecommendationModule,
    HierarchySelectorModule,
    SystemSelectorModule,
    NgSelectModule,
    LandingCardsModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [AppConfigService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    { provide: LocationStrategy, useClass: ParameterHashLocationStrategy },
    TitleCasePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
